import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgbTooltipConfig} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {TokenService} from './services/token.service';
import { Subscription } from 'rxjs';
import { IconBaseService } from './services/icon-base.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
    public hiddenTime!: number;

    public currentLanguage!: string;
    public appInitiated:boolean = false
    private subs = new Subscription()
    constructor(
        protected token: TokenService,
        protected ngbTooltip: NgbTooltipConfig,
        // protected socket: SocketService,
        private translate: TranslateService,
        private iconBaseService: IconBaseService,
    ) {
        ngbTooltip.container = 'body';
        document.onvisibilitychange = () => {
            if (document.visibilityState === 'visible') {
                if (!this.token.checkToken() || ((new Date().getTime() - this.hiddenTime) > 1800000)) {
                    this.token.rewriteToken();
                }
            }
            if (document.visibilityState === 'hidden') {
                this.hiddenTime = new Date().getTime();
            }
        };

        translate.setDefaultLang('ru');
        let storedLang = localStorage.getItem('language');
        if (storedLang==='undefined') {
          localStorage.setItem('language','ru')
          storedLang = 'ru'
        }
        const defaultLang = storedLang || 'ru';
        translate.setDefaultLang(defaultLang);
        translate.use(defaultLang);
        localStorage.setItem('language', defaultLang);
    }
    public ngOnDestroy(): void {
      this.subs.unsubscribe()
    }
    public ngOnInit(): void {
      this.subs.add((this.token.subAppInitiated.asObservable().subscribe(()=>this.appInitiated=true)))
      this.token.startTimer();
       // this.socket.runNotify();
    }
}
